export default {
  ja:[
    "注意！",
    "本当にこのリクエストを消してよろしいですか？（消してしまったら戻せません）",
    "リクエストの削除",
    "閉じる",
    "削除",
    "編集",
  ],
  en: [
    "Caution!",
    "Do you really want to delete this request?",
    "Delete Request",
    "Cancel",
    "Delete",
    "Edit",
  ]
}
